<div class="d-flex mt-3">
    <!-- retirado checkbox all da tela devido não estar sendo usado no momento -->
    <!-- <div class="mr-2 d-flex">
        <cdx-checkbox class="mt-1" [options]="checkboxOptions" (checked)="onCheckAllChange($event)"></cdx-checkbox>
        <span class="selecionar-todos">{{ "selectAll" | translate | titlecase }}</span>
    </div> -->
    <div class="mt-1">
        <cdx-filter
            *ngIf="filterOptions"
            [options]="filterOptions"
            (click)="onFilterClick($event)"
            (cleanFilter)="onClearFilter($event)"
            (filterEmmiter)="onfilter($event)">
        </cdx-filter>
    </div>
    <div class="d-flex flex-grow-1 ml-auto justify-content-end">
        <cdx-toolbar-search
            (onTyping)="onSearch($event)"
            [value]="searchValue"
            [placeholder]="'search' | translate | titlecase"
            [maxlength]="255"
            [debounceTime]="600"
        >
        </cdx-toolbar-search>
        <cdx-custom-dropdown
            *ngIf="hasSortOptions(); else legacySortButton"
            #sortDropdown
            class="sort-menu sent-sort-order-onboarding mx-1"
            [options]="sortDropdownOptions"
            ngbTooltip="{{ 'envelope.list.changeSortOrder' | translate }}"
            [attr.aria-label]="'envelope.list.changeSortOrder' | translate"
            (onSelectItem)="onSortDropdownSelect($event)"
        >
        </cdx-custom-dropdown>

        <ng-template #legacySortButton>
            <button class="cdx-button cdx-button--icon border-less button-right sent-sort-order-onboarding mx-1" (click)="onSortClick()" ngbTooltip="{{ 'envelope.list.changeSortOrder' | translate }}">
                <fa-icon class="fa-fw cdx-button__icon" [icon]="['far', getSortOrderIcon() ]"></fa-icon>
            </button>
        </ng-template>

        <button class="cdx-button cdx-button--icon border-less button-right mr-1 hidden-mobile" (click)="onGridModeClick()" ngbTooltip="{{ 'envelope.list.changeToGridMode' | translate }}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','th-large']"></fa-icon>
        </button>

        <button class="cdx-button cdx-button--icon border-less button-right hidden-mobile" (click)="onListModeClick()" ngbTooltip="{{ 'envelope.list.changeToListMode' | translate }}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','th-list']"></fa-icon>
        </button>
    </div>
</div>
<div class="d-flex flex-column mt-4">
    <cdx-bar-filter></cdx-bar-filter>
</div>

<cdx-onboarding-tour
    class="sort-order-onboarding-tour"
    onboardingId="sentSortOrderOnboarding"
    *ngIf="showSortOnboarding"
  [options]="sortOnboarding"
  (onCloseTour)="handleCloseSortOnboarding()">
</cdx-onboarding-tour>
